import type {AppTopbarRef} from "../types";
import {forwardRef, useContext, useImperativeHandle, useRef, useState} from "react";
import AppBreadcrumb from "./AppBreadCrumb";
import {LayoutContext} from "./context/LayoutContext";
import {Avatar} from "primereact/avatar";
import {InputText} from "primereact/inputtext";


const AppTopbar = forwardRef<AppTopbarRef>((props, ref) => {
    const {onMenuToggle, showProfileSidebar, showConfigSidebar, globalSearchModal, setGlobalSearchModal} =
        useContext(LayoutContext);
    const menubuttonRef = useRef(null);


    const onConfigButtonClick = () => {
        showConfigSidebar();
    };

    useImperativeHandle(ref, () => ({
        menubutton: menubuttonRef.current,
    }));

    const HandleGlobalSearchClick = () => {
        // console.log("before click",globalSearchModal)
        setGlobalSearchModal(!globalSearchModal);
        // console.log("after click",globalSearchModal)
    }

    return (
        <div className="layout-topbar">
            <div className="topbar-start">
                <button
                    ref={menubuttonRef}
                    type="button"
                    className="topbar-menubutton p-link p-trigger"
                    onClick={onMenuToggle}
                >
                    <i className="pi pi-bars"></i>
                </button>

                <AppBreadcrumb className="topbar-breadcrumb"></AppBreadcrumb>
            </div>

            <div className="topbar-end">
                <ul className="topbar-menu">
                    <li className="topbar-search list-none" onClick={HandleGlobalSearchClick}
                        style={{cursor: 'pointer'}}>
                        {/* Added 'relative flex align-items-center' to ensure the child absolute div centers correctly */}
                        <span className="p-input-icon-left p-input-icon-right w-full relative flex align-items-center">
                            <i className="pi pi-search"/>
                             <InputText
                                type="text"
                                placeholder="Search"
                                className="w-12rem sm:w-full border-round-lg"
                                readOnly
                             />

                            {/* This div is now relative to the span above */}
                            <div
                                className="absolute right-0 mr-2 flex align-items-center  pointer-events-none"
                                style={{
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    zIndex: 5
                                }}
                            >
                                <kbd className=" surface-border border-round px-2 py-1  text-500 font-bold text-xs " style={{minWidth: '1.5rem', textAlign: 'center'}}>
                                {/*{window.navigator.platform.includes('Mac') ? '⌘' : 'Ctrl'}*/}
                                    Ctrl/⌘
                                </kbd>
                                <kbd className=" surface-border border-round px-2 py-1  text-500 font-bold text-xs " style={{minWidth: '1.5rem', textAlign: 'center'}}>
                                    +
                                </kbd>
                                <kbd className=" surface-border border-round px-2 py-1  text-500 font-bold text-xs " style={{minWidth: '1.5rem', textAlign: 'center'}}>
                                    K
                                </kbd>
                            </div>
                        </span>
                    </li>
                    {/*<li className="ml-3">*/}
                    {/*    <Button*/}
                    {/*        type="button"*/}
                    {/*        icon="pi pi-cog"*/}
                    {/*        text*/}
                    {/*        rounded*/}
                    {/*        severity="secondary"*/}
                    {/*        className="flex-shrink-0"*/}
                    {/*        onClick={onConfigButtonClick}*/}
                    {/*    ></Button>*/}
                    {/*</li>*/}
                    <li className="topbar-profile">
                        <button
                            type="button"
                            className="p-link"
                            onClick={showProfileSidebar}
                        >
                            <Avatar icon={"pi pi-user"} shape="circle" className={"bg-primary"}/>
                            {/*<img*/}
                            {/*    src="/layout/images/avatar/avatar.png"*/}
                            {/*    alt="Profile"*/}
                            {/*/>*/}
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
});

AppTopbar.displayName = "AppTopbar";

export default AppTopbar;
